import { render, staticRenderFns } from "./DPCMember.vue?vue&type=template&id=184dcc5b&scoped=true&"
import script from "./DPCMember.vue?vue&type=script&lang=js&"
export * from "./DPCMember.vue?vue&type=script&lang=js&"
import style0 from "./../assets/mobileStyle.css?vue&type=style&index=0&id=184dcc5b&prod&scoped=true&lang=css&"
import style1 from "./DPCMember.vue?vue&type=style&index=1&id=184dcc5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184dcc5b",
  null
  
)

export default component.exports